import React from "react";

import config from "../../config";
import IconCar from "../components/icons/Car";
import IconCarKey from "../components/icons/CarKey";
import IconPhone from "../components/icons/Phone";

const SectionHowToNullLeasing = ({ bgColor = "white", borderTop }) => (
  <section
    id="so-funktionierts"
    className={`py-16 lg:py-24 border-b bg-${bgColor} ${
      borderTop ? "border-t" : ""
    }`}
  >
    <div className="page-container px-5">
      <div data-type-mapping="advantages_cards">
        <header className="text-center">
          <h2 className="headline--4 mb-10 lg:mb-20">
            So einfach funktioniert Auto Leasing bei
            {" "}
            {config.websiteName}
          </h2>
        </header>
        <div className="text-center lg:flex">
          <div className="py-5 lg:px-5 flex flex-col items-center lg:w-1/3">
            <div className="mb-4">
              <IconCar />
            </div>
            <h3 className="headline--6 text-secondary mb-1">1. Auto aussuchen</h3>
            <p className="max-w-full">
              Finden Sie Ihr Traumauto zu erschwinglichen Monatsraten und
              vergleichen Sie ganz einfach die Angebote mehrerer Händler.
            </p>
          </div>
          <div className="py-5 lg:px-5 flex flex-col items-center lg:w-1/3">
            <div className="mb-4">
              <IconPhone />
            </div>
            <h3 className="headline--6 text-secondary mb-1">
              2. Kontakt zum Händler aufnehmen
            </h3>
            <p className="max-w-full">
              Nehmen Sie direkten Kontakt zum Händler auf und erhalten Sie schnell
              Ihr unverbindliches Angebot. Nach erfolgreicher Bonitätsprüfung
              werden Ihnen Ihre Vertragsunterlagen zugesandt.
            </p>
          </div>
          <div className="py-5 lg:px-5 flex flex-col items-center lg:w-1/3">
            <div className="mb-4">
              <IconCarKey />
            </div>
            <h3 className="headline--6 text-secondary mb-1">
              3. Auto abholen oder liefern lassen
            </h3>
            <p className="max-w-full">
              Sobald Ihre Vertragsunterlagen wieder beim Händler eintreffen,
              können Sie Ihr Fahrzeug beim Autohaus abholen oder nach Hause
              liefern lassen.
            </p>
          </div>
        </div>
      </div>
      <footer className="mt-5">
        <div className="border border-primary rounded py-8 bg-white" data-type-mapping="highlighted_box">
          <div className="px-2 flex flex-col items-center">
            <p className="text-primary text-lg font-bold text-center mb-3">
              In kürzester Zeit zu Ihrem Traumwagen!
            </p>
            <p className="text-center max-w-full md:max-w-lg sm:px-10">
              Bei sofort verfügbaren Angeboten erhalten Sie Ihr Fahrzeug in der
              Regel in nur 7 Tagen!
            </p>
          </div>
        </div>
      </footer>
    </div>
  </section>
);

export default SectionHowToNullLeasing;
